import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_waxraygc8s: FaireBrandEntity = {
  token: "b_waxraygc8s",
  type: "brand",
  name: "Infinite Jewels",
  avatarUrl:
    "https://cdn.faire.com/fastly/b5fa1907b6315585e7b46ea409bb1f5ea07f94aa94d85b5c40e1b923efdb8180.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/72a43efb85c0ed4ff012f389df04d08038578aa6dee4c1fb121f24a40bf7eb05.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b5fa1907b6315585e7b46ea409bb1f5ea07f94aa94d85b5c40e1b923efdb8180.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/72a43efb85c0ed4ff012f389df04d08038578aa6dee4c1fb121f24a40bf7eb05.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 35,
  isTopShop: true,
  isInsider: true,
  description:
    "At Infinite Jewels, we are dedicated to providing a wide assortment of jewelry pieces to retailers, independents, mom and pop shops, and resellers. Our focus is on offering a diverse selection of materials and categories, so that our customers can find the perfect piece for every occasion.\n\nWe take pride in our commitment to value-driven pricing, ensuring that our jewelry is accessible to a wide range of customers. Our goal is to offer quality jewelry at affordable prices, so that everyone can enjoy the beauty and elegance of fine jewelry.\n\nWith an ever-expanding selection of SKUs, we are constantly adding new merchandise to our assortment, ensuring that our customers have access to the latest styles and trends in the industry. From classic pieces to the latest fashion-forward designs, we strive to offer something for everyone.\n\nAt Infinite Jewels, we understand that every jewelry piece tells a unique story, and we are honored to be a part of your customers' traditions for generations to come. Our team of skilled artisans is dedicated to crafting every piece with the utmost attention to detail, ensuring that each piece is of the highest quality.\n\nThank you for choosing Infinite Jewels as your go-to source for a wide assortment of quality jewelry at value-driven prices. We look forward to serving you and your customers with the highest level of care and dedication.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:57.849Z",
    importedBy: "entity-db-cli",
  },
};
